var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_510_144518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_510_144518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9C6.9 9 6.60417 8.87917 6.3625 8.6375C6.12083 8.39583 6 8.1 6 7.75C6 7.4 6.12083 7.10417 6.3625 6.8625C6.60417 6.62083 6.9 6.5 7.25 6.5C7.6 6.5 7.89583 6.62083 8.1375 6.8625C8.37917 7.10417 8.5 7.4 8.5 7.75C8.5 8.1 8.37917 8.39583 8.1375 8.6375C7.89583 8.87917 7.6 9 7.25 9ZM2.5 11C2.225 11 1.98958 10.9021 1.79375 10.7063C1.59792 10.5104 1.5 10.275 1.5 10V3C1.5 2.725 1.59792 2.48958 1.79375 2.29375C1.98958 2.09792 2.225 2 2.5 2H3V1H4V2H8V1H9V2H9.5C9.775 2 10.0104 2.09792 10.2063 2.29375C10.4021 2.48958 10.5 2.725 10.5 3V10C10.5 10.275 10.4021 10.5104 10.2063 10.7063C10.0104 10.9021 9.775 11 9.5 11H2.5ZM2.5 10H9.5V5H2.5V10ZM2.5 4H9.5V3H2.5V4Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.99cbbc68f895807e1d3b6d24f3741557.svg";
export { ForwardRef as ReactComponent };